export default __webpack_public_path__ + "static/media/toShow-8-min.10199c9b.jpg";